import { Flex, Grid, Skeleton } from '@mantine/core';
import { IconMinus } from '@tabler/icons-react';
import CustomTitle from './ui/Title/CustomTitle';
import CustomCard from './ui/CustomCard/CustomCard';

export const SkeletonWithDate = () => {
  return (
    <Flex>
      <Skeleton visible={true} w={60} h={20} ml={0} mr={0} animate={false} />
      <IconMinus width={10} />
      <Skeleton w={30} h={20} animate={false} />
      <IconMinus width={10} />
      <Skeleton w={30} h={20} animate={false} />
    </Flex>
  );
}

export const SkeletonWithEmail = () => {
  return (
    <Flex>
      <Skeleton visible={true} w={50} h={20} animate={false} />
      <span style={{ margin: 0, padding: 0 }}>@</span>
      <Skeleton w={50} h={20} animate={false} />
      <span style={{ margin: 0, padding: 0 }}>.com</span>
    </Flex>
  );
}

export const SkeletonWithPhoneNumber = () => {
  return (
    <Flex>
      <Skeleton visible={true} w={120} h={20} animate={false} />
    </Flex>
  );
}
export const SkeletonWithDescription = () => {
  return (
    <Grid >
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }} mt={0} mb={0} pb={0}>
        <Skeleton visible={true} h={55} animate={false} />
      </Grid.Col>
    </Grid>
  )
}

export const SkeletonWithText = () => {
  return (
    <Flex>
      <Skeleton visible={true} w={100} h={20} animate={false} />
    </Flex>
  );
}

export const ProfileSkeleton = () => {
  return (<></>
    // <Grid>
    //   <Grid.Col span={{ base: 12, md: 2.5, lg: 1.2 }}>
    //     <Flex justify={{ base: 'center', sm: 'center', md: 'right' }}>
    //       <Skeleton height={70} circle mb={10} />
    //     </Flex>
    //   </Grid.Col>
    //   <Grid.Col span={{ base: 12, md: 9, lg: 10.8 }}>
    //     <Flex justify={{ base: 'center', sm: 'center', md: 'left' }}>
    //       <Skeleton height={30} mt={6} w={150} radius="xl" mb={10} />
    //     </Flex>
    //     <Skeleton height={40} radius="xl" />
    //   </Grid.Col>
    // </Grid>
  );
}


export const ProfilTabsWithSkeleton = () => {
  return (
    <>
     

      <CustomCard>
         <Flex justify={'space-between'}>
        <Skeleton visible={true} height={25} w={220} />
        <Skeleton visible={true} height={20} w={40} />
      </Flex>
        <Grid mt={10} justify='center' align='center'>
          {[...Array(20)].map((_, index) => (
            <Grid.Col key={index} span={{ base: 12, md: 6, lg: 6 }} mt={0} mb={0} pb={0}>
              <Skeleton height={35} mt={6} />
            </Grid.Col>
          ))}
        </Grid>
      </CustomCard>
    </>
  );
}


export const ProfilRemainingTabsWithSkeleton = () => {
  return (
    <>
      <Flex justify={'space-between'}>
        <Skeleton visible={true} height={25} w={220} />
        <Skeleton visible={true} height={25} w={180} />
      </Flex>
      <Flex justify={'right'} mt={10}>
        <Skeleton visible={true} height={20} w={40} />
      </Flex>
      <CustomCard>
        <Grid mt={10} justify='center' align='center'>
          {[...Array(20)].map((_, index) => (
            <Grid.Col key={index} span={{ base: 12, md: 6, lg: 6 }} mt={0} mb={0} pb={0}>
              <Skeleton height={35} mt={6} />
            </Grid.Col>
          ))}
        </Grid>
      </CustomCard>
    </>
  );
}

export const CardViewSkeleton = () => {
  return (

    <Grid mt={20} gutter="sm">
      {[...Array(9)].map((_, i) => (
        <Grid.Col key={i} span={{ base: 12, sm: 6, lg: 4 }}>
          <Skeleton visible={true} h={120} />
        </Grid.Col>
      ))}
    </Grid>

  );
};

export const EmailTemplatesSkeleton = () => {
  return (
    <>
      <Flex mb={4} >
        <Skeleton visible={true} height={50} m={1} />
        <Skeleton visible={true} height={50} m={1} />
      </Flex>
      <Flex >
        <Skeleton visible={true} height={300} m={1} />
        <Skeleton visible={true} height={300} m={1} />
      </Flex>
    </>
  )
}

export const ProfileViewTypeCardsSkeleton = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Flex justify={'space-between'}>
          <Skeleton visible={true} height={35} w={220} />
          <Skeleton visible={true} height={35} w={180} />
        </Flex>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={180} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={180} />
      </Grid.Col>
    </Grid>
  );
}

export const TeamMemberCardSkeleton = () => {
  return (
    <>
      <Skeleton visible={true} h={220} mb={10} />
      <Grid>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={130} mt={5} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} w={300} h={160} />
        </Grid.Col>
      </Grid>
    </>
  );
}

export const TimeSheetColorConfig = () => {
  return (
    <>

      <Grid>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={120} />
        </Grid.Col>
      </Grid>
    </>
  );
}

export const AllDocumentsWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={200} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={50} mr={20} />
        </Grid.Col>
      </Grid>
    </>
  );
}

export const AllDocumentsWithSkeletontabs = () => {
  return (
    <Grid mt={15}>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Flex justify={'space-between'}>
          <Skeleton visible={true} h={35} w={200} />
          <Skeleton visible={true} h={35} w={200} />
        </Flex>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={180} />
      </Grid.Col>
    </Grid>
  );
}

export const LayoutHeaderWithSkeleton = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={55} mt={5} />
      </Grid.Col>
    </Grid>
  );
}

export const LayoutNavbarWithSkeleton = () => {
  return (
    <Flex direction="column" gap="xs" p="md">
      {[...Array(11)].map((_, index) => (
        <div
          key={index}
          style={{
            height: '40px',
            backgroundColor: '#1e293b',
            borderRadius: '8px',
            opacity: 0.8,
          }}
        />
      ))}
    </Flex>
  );
}

export const LayoutFooterWithSkeleton = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={40} />
      </Grid.Col>
    </Grid>
  );
}

export const HomeContentSkeleton = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={40} w={300} mb={10} />
        <Skeleton visible={true} h={20} w={400} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Flex justify="space-between" align="center">
          <Skeleton visible={true} h={30} w={100} />
          <Skeleton visible={true} h={35} w={120} />
        </Flex>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <CustomCard>
          <Skeleton visible={true} h={25} w={150} mb={15} />
          <Skeleton visible={true} h={20} w="100%" mb={10} />
          <Skeleton visible={true} h={35} w={100} />
        </CustomCard>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }} pt={0}>
        <CustomCard>
          <Skeleton visible={true} h={25} w={150} mb={15} />
          <Skeleton visible={true} h={20} w="100%" mb={10} />
          <Skeleton visible={true} h={35} w={100} />
        </CustomCard>
      </Grid.Col>
    </Grid>
  );
}

export const DashboardWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={37} w={160} mt={10} mb={30} />
      </CustomTitle>
      <Grid>
        {[...Array(8)].map((_, index) => (
          <Grid.Col key={index} span={{ base: 12, md: 6, lg: 3 }} mt={0} mb={0} pb={0}>
            <Skeleton visible={true} h={110} />
          </Grid.Col>
        ))}
      </Grid>
    </>
  );
}


export const TimeSheetsWithSkeleton = () => {
  return (
    <Grid>
      <Grid.Col span={{ base: 12, md: 4, lg: 3 }}>
        <Skeleton visible={true} h={300} mb={30} />
      </Grid.Col>

      <Grid.Col span={{ base: 12, md: 8, lg: 9 }}>
        <Skeleton visible={true} h={300} mb={30} />
      </Grid.Col>
    </Grid>
  );
}

export const AddTimeSheetsWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={400} mt={10} mb={30} />
      </CustomTitle>
    </>
  );
}

export const CompanyAndCustomerLocationAdressWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={280} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={180} />
        </Grid.Col>
      </Grid>
    </>
  );
}


export const CustomerProjectUsersAndRolesWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={280} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={180} />
        </Grid.Col>
      </Grid>
    </>
  );
}

export const OrganizationBasicInfoSkeleton = () => {
  return (
    <CustomCard>
      <Grid mt={20} gutter="xl">
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={50} w={150} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={120} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={40} />
        </Grid.Col>
      </Grid>
    </CustomCard>
  );
}


export const CompanyBankAccountsWithSkeleton = () => {
  return (
    <div>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={280} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={180} />
        </Grid.Col>
      </Grid>
    </div>
  );
}



export const CompanyBasicInfoWithSeleton = () => {
  return (
    <Grid ml={20}>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={180} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
        <Skeleton visible={true} h={280} />
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
        <Skeleton visible={true} h={280} />
      </Grid.Col>
    </Grid>
  );
}

export const TeammemberWithSeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={37} w={200} mt={10} mb={30} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={50} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Flex justify={'space-between'}>
            <Skeleton visible={true} h={37} w={200} mt={10} />
            <Skeleton visible={true} h={37} w={200} mt={10} />
          </Flex>
        </Grid.Col>
      </Grid>
    </>
  );
}


export const CompanyAndCustomerSignatoriesWithSkeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={280} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={180} />
        </Grid.Col>
      </Grid>
    </>
  );
}

interface Props{
  height?: number;
  width?: number | string;
}

export const DocumentSkeleton = ({height, width}: Props) => {
  return (
    <Flex direction={'column'}>
      <Skeleton height={height ||50} mb="sm" width={width || '100%'} radius={'md'}/>
      <Skeleton height={height ||50} mb="sm" width={width || '100%'} radius={'md'}/>
    </Flex>
  )
}

export const CompanyAndCustomerWithSeleton = () => {
  return (
    <>
      <CustomTitle>
        <Skeleton visible={true} h={30} w={280} mt={10} mb={20} />
      </CustomTitle>
      <Grid ml={20}>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={40} mr={20} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
          <Skeleton visible={true} h={180} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 12, lg: 6 }}>
          <Skeleton visible={true} h={280} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 6 }}>
          <Skeleton visible={true} h={280} />
        </Grid.Col>
      </Grid>
    </>
  );
}


export const ConfigurationWithSkeleton = () => {
  return (
    <Grid mt={15}>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Flex justify={'space-between'}>
          <Skeleton visible={true} h={35} w={200} />
          <Skeleton visible={true} h={35} w={200} />
        </Flex>
      </Grid.Col>
      <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
        <Skeleton visible={true} h={180} />
      </Grid.Col>
    </Grid>
  );
}

export const LogoWithSkeleton = () => {
  return (
    <Skeleton visible={true} h={50} w={140} />
  );
}

export const AssetSkeleton = () => {
  return (
    <>
      <Grid gutter="md" pl={15}>
        <Grid.Col span={6}>
          <Skeleton height={35} />
        </Grid.Col>
        <Grid.Col span={6}>
          <Skeleton height={35} />
        </Grid.Col>
      </Grid>

      {Array.from({ length: 4 }).map((_, outerindex) => (
        <Grid key={`${outerindex}`} gutter="md" mt={10} pl={15}>
          {Array.from({ length: 3 }).map((_, innerindex) => (
            <Grid.Col key={`${innerindex}`} span={4}>
              <Skeleton height={35} />
            </Grid.Col>
          ))}
        </Grid>
      ))}

    </>
  )
}
